/**
 * 牵线前在微信内请求一次性订阅消息（须在用户点击手势内调用 wx.requestSubscribeMessage）
 */

export const WX_MATCH_SUBSCRIBE_TMPL_IDS = [
  'etVMceLkkQBdiCqjAF0xOjrXeCni0WWOJrgcI3_omXI', // 好友申请通知
  'IkMpkD5b4DCp2C2ZboOMikl94SwHZYORjfEa8-8N1FE' // 聊天消息通知
];

const FRIEND_APPLY_TMPL_ID = WX_MATCH_SUBSCRIBE_TMPL_IDS[0];

const isWeChatBrowser = () =>
  typeof window !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent || '');

function whenWxJssdkReady() {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || !window.wx) {
      resolve();
      return;
    }
    window.wx.ready(() => resolve());
  });
}

/**
 * @param {() => Promise<void>} doMatch — 实际发起牵线请求（API 调用）
 * 微信内且支持 requestSubscribeMessage 时先弹订阅；用户同意「好友申请」模板后再执行 doMatch。
 * 订阅失败或非微信环境与不支持时直接执行 doMatch，避免阻断牵线。
 */
export async function runMatchAfterSubscribe(doMatch) {
  if (!isWeChatBrowser()) {
    await doMatch();
    return;
  }
  const { wx } = window;
  if (!wx || typeof wx.requestSubscribeMessage !== 'function') {
    await doMatch();
    return;
  }

  await whenWxJssdkReady();

  await new Promise((resolve, reject) => {
    wx.requestSubscribeMessage({
      tmplIds: [...WX_MATCH_SUBSCRIBE_TMPL_IDS],
      success(res) {
        if (res[FRIEND_APPLY_TMPL_ID] === 'accept') {
          Promise.resolve(doMatch()).then(resolve).catch(reject);
        } else {
          alert('为及时收到好友申请与聊天通知，请在订阅弹窗中选择「允许」后再发送牵线。');
          resolve();
        }
      },
      fail(err) {
        console.warn('订阅消息授权失败:', err);
        Promise.resolve(doMatch()).then(resolve).catch(reject);
      }
    });
  });
}
